module.exports = __webpack_public_path__ + "static/media/check.ea9ff0d9.svg";